import { getRole } from "helpers/permissions/roles"
import withNavigate from "hocs/withNavigate"
import createModule from "../createModule"
import { getSolutions } from "./selectors"
import view from "./view"

const SolutionsModule = createModule({
  view,
  externalProps: state => ({
    account: state.global.selected.account,
  }),
  required: ["account"],
  data: [
    {
      resource: "solutions",
      as: null,
      url: ({ account }) => `/api/${account}/solutions`,
    },
  ],
  mapStateToProps: (state, props) => ({
    solutions: getSolutions(state, props),
    role: getRole(state),
  }),
})

export default withNavigate(SolutionsModule)
